import { Divider, Grid, ListSubheader, MenuItem, TextField } from "@mui/material";
export function LeadStatusSelect(props) {
    return (
        <Grid item>
            <TextField
                select
                label={props.label}
                size="small"
                fullWidth
                defaultValue={
                    props.getValues("leadStatus") === "Failure"
                        ? props.getValues("statusReason")
                        : props.getValues("leadStatus")
                }
            >
                {props.leadsStatuses
                    .filter((v) => v.value !== "Failure")
                    .map((v) => (
                        <MenuItem
                            onClick={() => {
                                props.setValue("leadStatus", v.value);
                                props.setValue("statusReason", null);
                                props.setValue("statusNote", null);
                            }}
                            value={v.value}
                        >
                            {v.label}
                        </MenuItem>
                    ))}

                {props.failureReasons && (
                    <Grid item>
                        <Divider sx={{ mx: 1 }} />
                        <ListSubheader sx={{ mt: 1, lineHeight: "unset" }}>Fiasko</ListSubheader>
                    </Grid>
                )}
                {props.failureReasons?.map((v) => (
                    <MenuItem
                        onClick={() => {
                            console.log(v);
                            props.setValue("leadStatus", "Failure");
                            props.setValue("statusReason", v.value);
                        }}
                        value={v.value}
                    >
                        Fiasko - {v.label}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    );
}
